import { render } from "./TheSetting.vue?vue&type=template&id=27cacd68"
import script from "./TheSetting.vue?vue&type=script&lang=js"
export * from "./TheSetting.vue?vue&type=script&lang=js"

import "./TheSetting.vue?vue&type=style&index=0&id=27cacd68&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__